fragment DocumentNatifMetadata on Document {
  id
  natifMetadata {
    date
    scanId
  }
}
